(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-hero-cleansers"] && !Shopify.designMode) return;
  try {
    
  class CleansersHero extends HTMLElement {
    currentCleanserIndex = 0;
    activeFloaties = new Map();
    cleanserRotation = null;

    $cleansers = null;
    $cleansersButtonsBox = null;
    $cleanserButtons = null;
    $contentSlide = null;

    connectedCallback() {
      // init $dom
      this.$cleansersButtonsBox = this.querySelector('nav-buttons');
      this.$cleanserButtons = this.querySelectorAll('nav-button > button');
      this.$cleansers = this.querySelectorAll('cleanser-box');
      if (!this.$cleansers) { return }

      this.initCleanser();
    }

    disconnectedCallback() {
      return;
    }

    setupMobileNavigationTracker = () => {
      const { $cleansersButtonsBox, $cleanserButtons } = this;
      const btnAlignments = ['start', 'center', 'end'];

      $cleanserButtons.forEach(($cleanserButton) => {
        $cleanserButton.addEventListener('click', function() {
          if (window.innerWidth >= 496) return;

          const btnIndex = [...$cleansersButtonsBox.children].indexOf($cleanserButton.parentElement);
          $cleanserButton.scrollIntoView({
            behavior: 'smooth',
            inline: btnAlignments[btnIndex],
            block: 'nearest'
          });
        });
      });

      const setupCurrentMobileNavItem = function() {
        if (window.innerWidth >= 496) return;

        const $currentNavButton = $cleanserButton.querySelector('nav-button:has(button[current])');
        const currentIndex = [...$cleanserButton.children].indexOf($currentNavButton);

        if (currentIndex > 0) {
          $currentNavButton.scrollIntoView({
            behavior: 'instant',
            inline: btnAlignments[currentIndex],
            block: 'nearest'
          });
        }
      }();
    }

    setupMobileHeightTracker = ($cleanser) => {
      const $trackedEl = $cleanser.querySelector('content-slide');
      const $wrapper = $cleanser.querySelector('shot-box');
      const $pinnedElements = $cleanser.querySelectorAll('product-shot image-box, product-shadow image-box');

      if (!$trackedEl || !$wrapper || !$pinnedElements.length) return;

      const resizeObserver = new ResizeObserver(async () => {
        const $textBox = $trackedEl.querySelector('cleanser-content');
        const containerHeight = $wrapper.getBoundingClientRect().height;

        if (containerHeight === 0) return;
        const textHeight = $textBox.offsetHeight;

        const remainingHeight = containerHeight - textHeight;
        const remainingPercentage =  Math.round(((containerHeight - textHeight) / containerHeight) * 100);

        $pinnedElements.forEach(($pinnedEl) => {
          $pinnedEl.style.setProperty('--productShotHeight', `${remainingPercentage}%`);
        });
      });

      // Start observing the tracked element
      resizeObserver.observe($trackedEl);
    }

    setupBGShader = ($cleanser) => {
      const $canvas = $cleanser.querySelector('background-box canvas');
      if (!$canvas) return;

      const gl = $canvas.getContext('webgl');
      if (!gl) {
        console.error("WebGL not supported in this browser.");
        return;
      }

      const onCanvasResize = function() {
        const rect = $canvas.getBoundingClientRect();
        const { width: canvasWidth, height: canvasHeight } = rect;

        if (canvasWidth === 0 || canvasHeight ===  0) return;

        $canvas.width = canvasWidth * window.devicePixelRatio;
        $canvas.height = canvasHeight * window.devicePixelRatio;
        gl.viewport(0, 0, $canvas.width, $canvas.height);
      }

      $canvas._onResize = onCanvasResize;
      window.addEventListener('resize', onCanvasResize);
      onCanvasResize();

      const vsSource = `
        attribute vec2 position;
        varying vec2 vUv;
        void main() {
          vUv = position * 0.5 + 0.5;
          gl_Position = vec4(position, 0.0, 1.0);
        }
      `;
      const fsSource = `
        precision highp float;
        varying vec2 vUv;
        uniform float uTime;
        uniform float uSeed;
        uniform float uSpeed;
        uniform vec2 uFreq;
        uniform float uAngle;
        uniform float uAmplitude;
        uniform float uSoftness;
        uniform float uBlend;
        uniform vec2 uResolution;

        uniform vec3 uColor1;
        uniform vec3 uColor2;
        uniform vec3 uColor3;
        uniform vec3 uColor4;

        vec3 permute(vec3 x) { return mod(((x*34.0)+1.0)*x, 289.0); }

        float snoise(vec2 v){
          const vec4 C = vec4(0.211324865405187, 0.366025403784439,
                            -0.577350269189626, 0.024390243902439);
          vec2 i  = floor(v + dot(v, C.yy) );
          vec2 x0 = v -   i + dot(i, C.xx);
          vec2 i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);
          vec4 x12 = x0.xyxy + C.xxzz;
          x12.xy -= i1;
          i = mod(i, 289.0);
          vec3 p = permute( permute( i.y + vec3(0.0, i1.y, 1.0 ))
                + i.x + vec3(0.0, i1.x, 1.0 ));
          vec3 m = max(0.5 - vec3(dot(x0,x0), dot(x12.xy,x12.xy), dot(x12.zw,x12.zw)), 0.0);
          m = m*m;
          m = m*m;
          vec3 x = 2.0 * fract(p * C.www) - 1.0;
          vec3 h = abs(x) - 0.5;
          vec3 ox = floor(x + 0.5);
          vec3 a0 = x - ox;
          m *= 1.79284291400159 - 0.85373472095314 * ( a0*a0 + h*h );
          vec3 g;
          g.x  = a0.x  * x0.x  + h.x  * x0.y;
          g.yz = a0.yz * x12.xz + h.yz * x12.yw;
          return 130.0 * dot(m, g);
        }

        void main() {
          vec2 st = (vUv - 0.5) * vec2(uResolution.x / uResolution.y, 1.0);
          float rad = radians(uAngle);
          mat2 rot = mat2(cos(rad), -sin(rad), sin(rad), cos(rad));
          st = rot * st;
          float t = (uTime * 0.4 + uSeed) * uSpeed;
          vec2 p = st * (uFreq * 0.18);
          float n1 = snoise(p + vec2(t * 0.3, t * 0.2)) * uAmplitude;
          float n2 = snoise(p * 1.5 - vec2(t * 0.4, -t * 0.3) + vec2(n1)) * uAmplitude;
          float n3 = snoise(p * 0.8 + vec2(n2 * 1.2, t * 0.15));
          float mixFactor = clamp(n3 * 0.5 + 0.5, 0.0, 1.0);
          float soft = max(uSoftness, 0.05);
          vec3 colorAB = mix(uColor1, uColor2, smoothstep(0.0, 0.5 + soft * 0.3, mixFactor));
          vec3 colorCD = mix(uColor3, uColor4, smoothstep(0.5 - soft * 0.3, 1.0, mixFactor));
          vec3 finalColor = mix(colorAB, colorCD, smoothstep(0.1, 0.9, mixFactor * uBlend));
          float grain = (fract(sin(dot(vUv, vec2(12.9898, 78.233))) * 43758.5453) - 0.5) * 0.015;
          gl_FragColor = vec4(finalColor + grain, 1.0);
        }
      `;
      const createShader = function(gl, type, source) {
        const shader = gl.createShader(type);
        gl.shaderSource(shader, source);
        gl.compileShader(shader);
        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
          console.error(gl.getShaderInfoLog(shader));
          gl.deleteShader(shader);
          return null;
        }
        return shader;
      };
      const vs = createShader(gl, gl.VERTEX_SHADER, vsSource);
      const fs = createShader(gl, gl.FRAGMENT_SHADER, fsSource);
      const program = gl.createProgram();
      gl.attachShader(program, vs);
      gl.attachShader(program, fs);
      gl.linkProgram(program);

      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
        console.error(gl.getProgramInfoLog(program));
        return;
      }
      gl.useProgram(program);

      const buffer = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([
        -1, -1,   1, -1,  -1,  1,
        -1,  1,   1, -1,   1,  1,
      ]), gl.STATIC_DRAW);
      const positionLoc = gl.getAttribLocation(program, "position");
      gl.enableVertexAttribArray(positionLoc);
      gl.vertexAttribPointer(positionLoc, 2, gl.FLOAT, false, 0, 0);
      const uniforms = {
        uTime: gl.getUniformLocation(program, "uTime"),
        uSeed: gl.getUniformLocation(program, "uSeed"),
        uSpeed: gl.getUniformLocation(program, "uSpeed"),
        uFreq: gl.getUniformLocation(program, "uFreq"),
        uAngle: gl.getUniformLocation(program, "uAngle"),
        uAmplitude: gl.getUniformLocation(program, "uAmplitude"),
        uSoftness: gl.getUniformLocation(program, "uSoftness"),
        uBlend: gl.getUniformLocation(program, "uBlend"),
        uResolution: gl.getUniformLocation(program, "uResolution"),
        uColor1: gl.getUniformLocation(program, "uColor1"),
        uColor2: gl.getUniformLocation(program, "uColor2"),
        uColor3: gl.getUniformLocation(program, "uColor3"),
        uColor4: gl.getUniformLocation(program, "uColor4")
      };
      const hexToRgb = function(hex) {
        hex = hex.replace('#', '');
        if (hex.length === 3) hex = hex.split('').map(c => c + c).join('');
        const num = parseInt(hex, 16);
        return [
          ((num >> 16) & 255) / 255,
          ((num >> 8) & 255) / 255,
          (num & 255) / 255
        ];
      };

      const seed = parseFloat($canvas.dataset.seed);
      const speed = parseFloat($canvas.dataset.speed);
      const freqX = parseFloat($canvas.dataset.freqX);
      const freqY = parseFloat($canvas.dataset.freqY);
      const angle = parseFloat($canvas.dataset.angle);
      const amplitude = parseFloat($canvas.dataset.amplitude);
      const softness = parseFloat($canvas.dataset.softness);
      const blend = parseFloat($canvas.dataset.blend);

      const c1 = hexToRgb($canvas.dataset.color1);
      const c2 = hexToRgb($canvas.dataset.color2);
      const c3 = hexToRgb($canvas.dataset.color3);
      const c4 = hexToRgb($canvas.dataset.color4);

      gl.uniform1f(uniforms.uSeed, seed);
      gl.uniform1f(uniforms.uSpeed, speed);
      gl.uniform2f(uniforms.uFreq, freqX, freqY);
      gl.uniform1f(uniforms.uAngle, angle);
      gl.uniform1f(uniforms.uAmplitude, amplitude);
      gl.uniform1f(uniforms.uSoftness, softness);
      gl.uniform1f(uniforms.uBlend, blend);
      gl.uniform3fv(uniforms.uColor1, c1);
      gl.uniform3fv(uniforms.uColor2, c2);
      gl.uniform3fv(uniforms.uColor3, c3);
      gl.uniform3fv(uniforms.uColor4, c4);

      let startTime = performance.now();
      let animFrameId = null;

      const canvasRender = function() {
        if ($cleanser.hasAttribute('current')) {
          gl.uniform1f(uniforms.uTime, (performance.now() - startTime) * 0.001);
          gl.uniform2f(uniforms.uResolution, $canvas.width, $canvas.height);
          gl.drawArrays(gl.TRIANGLES, 0, 6);
        }
        animFrameId = requestAnimationFrame(canvasRender);

      };
      animFrameId = requestAnimationFrame(canvasRender);

      $canvas._destroyBGShader = function() {
        if (animFrameId) cancelAnimationFrame(animFrameId);
        window.removeEventListener('resize', onCanvasResize);
      };

      $canvas.removeAttribute('unrendered');

      document.addEventListener('shopify:section:select', (e) => {
        if (e.detail.sectionId === this.dataset.sectionId) onCanvasResize();
      });
    }

    applyFloatyEffect = ($wrapper, options = {}) => {
      if (!$wrapper) return () => {};

      const $floaty = $wrapper.querySelector('img');
      if (!$floaty) return () => {};

      // Fine-tuned defaults for ultra-subtle drift
      const {
        maxTranslationX = 3,  // Max offset in px (keep small for subtle feel)
        maxTranslationY = 6,  // Max offset in px
        maxRotation = 2.5,    // Max rotation in degrees
        maxScale = 0.02,     // Scale between 1 and 1 + maxScale
        speed = 0.0008,        // Lower = slower, smoother float
      } = options;

      // Generate unique, randomized frequency and phase shifts for this specific element
      const freqX = 0.7 + Math.random() * 0.5;
      const freqY = 0.5 + Math.random() * 0.5;
      const freqR = 0.3 + Math.random() * 0.4;
      const freqS = 0.4 + Math.random() * 0.4;

      const phaseX = Math.random() * Math.PI * 2;
      const phaseY = Math.random() * Math.PI * 2;
      const phaseR = Math.random() * Math.PI * 2;
      const phaseS = Math.random() * Math.PI * 2;

      let animationFrameId = null;
      let startTime = null;

      const updateTransform = function(timestamp) {
        if (!startTime) startTime = timestamp;
        const elapsed = (timestamp - startTime) * speed;

        // Calculate fluid, non-repeating offsets using combined sine curves
        const x = Math.sin(elapsed * freqX + phaseX) * maxTranslationX;
        const y = Math.sin(elapsed * freqY + phaseY) * maxTranslationY;
        const rot = Math.sin(elapsed * freqR + phaseR) * maxRotation;
        const scale = 1 + ((Math.sin(elapsed * freqS + phaseS) + 1) / 2) * maxScale;

        // Apply via hardware-accelerated transform
        $floaty.style.transform = `translate3d(${x.toFixed(2)}px, ${y.toFixed(2)}px, 0px) rotate(${rot.toFixed(2)}deg) scale(${scale.toFixed(3)})`;

        animationFrameId = requestAnimationFrame(updateTransform);
      };

      // Start loop
      animationFrameId = requestAnimationFrame(updateTransform);

      // Return cleanup function for memory management
      return function destroy() {
        if (animationFrameId) {
          cancelAnimationFrame(animationFrameId);
        }
        $floaty.style.transform = ''; // Reset style inline
      };
    }

    setupFloaties = ($cleanser) => {
      const { applyFloatyEffect, activeFloaties } = this;
      const $floaties = $cleanser.querySelectorAll('floaties-box floaty-wrapper');

      $floaties.forEach($floaty => {
        const floatyCleanup = applyFloatyEffect($floaty);

        activeFloaties.set($floaty, floatyCleanup);
      });
    }

    toggleCleanser = (e) => {
      const {
        cleanserRotation,
        setCurrentCleanser,
        stopCleanserRotation
      } = this;
      const $clickedButton = e.currentTarget;
      const newIndex = [...$clickedButton.parentElement.parentElement.children].indexOf($clickedButton.parentElement);

      if ($clickedButton.hasAttribute('current')) return;

      if (cleanserRotation) stopCleanserRotation();
      setCurrentCleanser(newIndex);
    }

    setCurrentCleanser = (newIndex) => {
      const {
        $cleansers,
        $cleanserButtons,
        currentCleanserIndex,
       } = this;

      if (currentCleanserIndex != newIndex) {
        $cleanserButtons[currentCleanserIndex].removeAttribute('current');
        $cleanserButtons[currentCleanserIndex].setAttribute('aria-selected', 'false');
        $cleanserButtons[currentCleanserIndex].setAttribute('tabindex', '-1');

        $cleansers[currentCleanserIndex].removeAttribute('current');

        this.currentCleanserIndex = newIndex;
      }

      $cleanserButtons[newIndex].setAttribute('current', '');
      $cleanserButtons[newIndex].setAttribute('aria-selected', 'true');
      $cleanserButtons[newIndex].setAttribute('tabindex', '0');

      $cleansers[newIndex].setAttribute('current', '');

      requestAnimationFrame(() => {
        const $canvas = $cleansers[newIndex].querySelector('background-box canvas');
        if ($canvas && typeof $canvas._onResize === 'function') {
          $canvas._onResize();
        }
      });
    }

    handleBrowserTabVisibilityChange = () => {
      const { stopCleanserRotation, startCleanserRotation } = this;

      if (document.hidden) {
        stopCleanserRotation();
      } else {
        // Only restart if the user hasn't manually interacted or focused an element
        startCleanserRotation();
      }
    }

    startCleanserRotation = () => {
      const {
        currentCleanserIndex,
        setCurrentCleanser
      } = this;

      let newIndex = currentCleanserIndex + 1;
      newIndex = newIndex === 3 ? 0 : newIndex;
      setCurrentCleanser(newIndex);
    }

    stopCleanserRotation = () => {
      const { cleanserRotation } = this;

      clearInterval(cleanserRotation);
    }

    trackATCButtonClicks = (e) => {
      const $clickedCleanser = e.currentTarget;
    }

    initCleanser = () => {
      const {
        $cleansers,
        $cleanserButtons,
        setupBGShader,
        setupFloaties,
        toggleCleanser,
        setupMobileNavigationTracker,
        setupMobileHeightTracker,
        setCurrentCleanser,
        stopCleanserRotation,
        startCleanserRotation,
        handleBrowserTabVisibilityChange,
        trackATCButtonClicks,
      } = this;

      $cleansers.forEach($cleanser => {
        setupBGShader($cleanser);
        setupFloaties($cleanser);
        setupMobileHeightTracker($cleanser);

        $cleanser.addEventListener('click', trackATCButtonClicks);
      });

      setupMobileNavigationTracker();
      $cleanserButtons.forEach(($cleanserButton) => {
        $cleanserButton.addEventListener('click', toggleCleanser);
      });

      document.addEventListener('visibilitychange', handleBrowserTabVisibilityChange);
      this.cleanserRotation = setInterval(startCleanserRotation, 8000);
      this.addEventListener('focusin', stopCleanserRotation);
      setCurrentCleanser(0);
    }
  }

  (function() {
    const initCleansersHero = () => {
      customElements.define('cleansers-hero', CleansersHero);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCleansersHero, { once: true });
    } else {
      initCleansersHero();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-hero-mobile-stacked"] && !Shopify.designMode) return;
  try {
    
  /*
  const $legalTextPopup = document.querySelector('#header-legal-popup-');
  const $legalTextCTA = document.querySelector('#header-legal-cta-');
  const $legalTextBG = $legalTextPopup.querySelector('.legal-text__bg');
  const $legalTextCloseButtons = $legalTextPopup.querySelectorAll('button');

  const openLegalPopup = function() {
    $legalTextPopup.setAttribute('active', true);
    setTimeout(function() {
      $legalTextPopup.setAttribute('visible', true);
    }, 100);

    window.addEventListener('scroll', closeLegalPopup);
  };

  const closeLegalPopup = function() {
    $legalTextPopup.removeAttribute('visible');

    setTimeout(function() {
      $legalTextPopup.removeAttribute('active');
    }, 800);

    window.removeEventListener('scroll', closeLegalPopup);
  };

  $legalTextCTA.addEventListener('click', openLegalPopup);
  $legalTextBG.addEventListener('click', closeLegalPopup);

  $legalTextCloseButtons.forEach(function($btn) {
    $btn.addEventListener('click', closeLegalPopup);
  });

  // close legal text if Escape key is pressed
  document.addEventListener('keydown', (e) => {
    if (e.key == 'Escape' && $legalTextPopup.hasAttribute('active')) {
      closeLegalPopup();
    }
  });
  */

  } catch(e) { console.error(e); }
})();
})();
